// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProfileModerationPage {
  padding-left: 281px;
  background: #eff0f4;
  width: 100%;
  min-height: 100vh;
}
.ProfileModerationPage .titleBlock {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: left;
  background: #fff;
  padding-top: 43px;
  padding-left: 40px;
  padding-bottom: 27px;
}
.ProfileModerationPage .titleBlock span {
  font-family: "Montserrat Regular", sans-serif;
  font-weight: 500;
  font-size: 24px;
}
.ProfileModerationPage .content {
  padding: 0 5% 40px;
}
.ProfileModerationPage .requestsGrid {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-top: 16px;
}
.ProfileModerationPage .requestCard {
  width: 280px;
  border: 1px solid #eee;
  border-radius: 8px;
  padding: 12px;
  background: #fff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}
.ProfileModerationPage .photoCompare {
  display: flex;
  gap: 8px;
  margin-bottom: 8px;
}
.ProfileModerationPage .photoCompare .photoBlock {
  flex: 1;
  text-align: center;
}
.ProfileModerationPage .photoCompare .photoBlock img {
  width: 100%;
  height: 100px;
  object-fit: cover;
  border-radius: 6px;
  background: #f5f5f5;
}
.ProfileModerationPage .photoCompare .photoBlock .label {
  font-size: 11px;
  color: #888;
  margin-top: 4px;
}`, "",{"version":3,"sources":["webpack://./src/routes/pages/ProfileModerationPage/ProfileModerationPage.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;AACF;AACE;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,oBAAA;AACJ;AACI;EACE,6CAAA;EACA,gBAAA;EACA,eAAA;AACN;AAGE;EACE,kBAAA;AADJ;AAIE;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,gBAAA;AAFJ;AAKE;EACE,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,wCAAA;AAHJ;AAME;EACE,aAAA;EACA,QAAA;EACA,kBAAA;AAJJ;AAMI;EACE,OAAA;EACA,kBAAA;AAJN;AAMM;EACE,WAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;AAJR;AAOM;EACE,eAAA;EACA,WAAA;EACA,eAAA;AALR","sourcesContent":[".ProfileModerationPage {\n  padding-left: 281px;\n  background: #eff0f4;\n  width: 100%;\n  min-height: 100vh;\n\n  .titleBlock {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: left;\n    background: #fff;\n    padding-top: 43px;\n    padding-left: 40px;\n    padding-bottom: 27px;\n\n    span {\n      font-family: 'Montserrat Regular', sans-serif;\n      font-weight: 500;\n      font-size: 24px;\n    }\n  }\n\n  .content {\n    padding: 0 5% 40px;\n  }\n\n  .requestsGrid {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 16px;\n    margin-top: 16px;\n  }\n\n  .requestCard {\n    width: 280px;\n    border: 1px solid #eee;\n    border-radius: 8px;\n    padding: 12px;\n    background: #fff;\n    box-shadow: 0 2px 6px rgb(0 0 0 / 10%);\n  }\n\n  .photoCompare {\n    display: flex;\n    gap: 8px;\n    margin-bottom: 8px;\n\n    .photoBlock {\n      flex: 1;\n      text-align: center;\n\n      img {\n        width: 100%;\n        height: 100px;\n        object-fit: cover;\n        border-radius: 6px;\n        background: #f5f5f5;\n      }\n\n      .label {\n        font-size: 11px;\n        color: #888;\n        margin-top: 4px;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ProfileModerationPage": `ProfileModerationPage`,
	"titleBlock": `titleBlock`,
	"content": `content`,
	"requestsGrid": `requestsGrid`,
	"requestCard": `requestCard`,
	"photoCompare": `photoCompare`,
	"photoBlock": `photoBlock`,
	"label": `label`
};
export default ___CSS_LOADER_EXPORT___;
